import {EmptyProps} from "../../common/empty/Empty.props";
import {ListColumnType, ListHeader} from "../../common/list/List.props";
import {CategoryInfo, CategoryType} from "./Category.type";

export const HEADERS: ListHeader[] = [
    {
        type: ListColumnType.CHECK_BOX,
        name: "",
        key: ""
    },
    {
        type: ListColumnType.NORMAL,
        name: "분류",
        key: "category",
        convertToString: (category: CategoryType): string => {
            return CategoryInfo.ordinalToName(category);
        }
    },
    {
        type: ListColumnType.LONG_TEXT,
        name: "제목",
        key: "title"
    }
];

export const EMPTY_PROPS = (handleButtonClick: () => void): EmptyProps => {
    return {
        messageText: "FAQ가 없습니다.",
        buttonText: "FAQ 추가하기",
        handleButtonClick: handleButtonClick
    };
}